import { useMemo } from 'react'

const DEFAULT_STEP_LABELS = ['Client', 'Coordonnées', 'Projet']

export function ProjectCreateProgress({
  currentStep,
  totalSteps,
  stepLabels = DEFAULT_STEP_LABELS,
}: {
  currentStep: number
  totalSteps: number
  stepLabels?: string[]
}) {
  const progressPercent = (currentStep / totalSteps) * 100

  const currentLabel = useMemo(() => {
    return stepLabels[currentStep - 1] || ''
  }, [currentStep, stepLabels])

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm text-muted-foreground">
          Étape {currentStep}/{totalSteps}
        </span>
        <span className="text-sm text-muted-foreground">{currentLabel}</span>
      </div>

      <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
        <div className="h-full bg-primary transition-all duration-300 ease-out" style={{ width: `${progressPercent}%` }} />
      </div>
    </div>
  )
}
